import React, { Component } from "react";
import LoaderStyle from "./LoaderStyle";
import isEmpty from "../../validation/is-empty";

class Loader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isShowLoader: Boolean(props.isShowLoader),
    };
  }

  componentDidUpdate(previousProp) {
    if (previousProp !== this.props) {
      this.setState({ isShowLoader: this.props.isShowLoader });
    }
  }

  render() {
    const { isShowLoader } = this.state;
    const statusText =
      this.props.loadingText && !isEmpty(this.props.loadingText)
        ? this.props.loadingText
        : null;

    return (
      <>
        {isShowLoader && (
          <div>
            {LoaderStyle}
            <div
              id="pageloader-overlay"
              className={`visible incoming${statusText ? " has-status" : ""}`}
            >
              <div className="loader-wrapper-outer">
                <div className="loader-wrapper-inner">
                  {statusText ? (
                    <div className="loader-status" role="status" aria-live="polite">
                      <div className="loader-status__spinner" aria-hidden="true" />
                      <p className="loader-status__title">{statusText}</p>
                      <p className="loader-status__hint">This only takes a moment</p>
                    </div>
                  ) : (
                    <div className="loader" />
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
}
export default Loader;
